import * as S from './FloatingAccount.styled';

import { mapGetters, mapActions, mapMutations } from 'vuex';

import { headOfString, isValueExist } from '@util';
import { ACCOUNT_ROLES_NEW } from '@consts';

import AddIcon from '@svgIcons/add.svg';
import LogoutIcon from '@svgIcons/logout.svg';
import CheckIcon from '@svgIcons/check.svg';
import ArrowIcon from '@svgIcons/descending.svg';

export default {
    data() {
        return {
            bottomVisible: false,
        };
    },
    computed: {
        ...mapGetters('user', [
            'user',
            'accountId',
            'account',
            'accounts',
            'defaultAccountId',
            'role',
        ]),
        routeMeta: R.pathOr({}, ['$route', 'meta']),
    },
    render() {
        const { floatingAccountVisible } = this.routeMeta;

        if (floatingAccountVisible === false || !isValueExist(this.accounts)) {
            return null;
        }
        const {
            bottomVisible,
            setBottomVisible,
            renderBottom,
            account = {},
        } = this;

        const accountAlias = headOfString(account.name) || 'd';

        let iconProps = {
            class: 'head-account-icon',
            attrs: {
                color: account.color,
            },
        };

        if (this.windowDimension.width > 800) {
            iconProps = R.assoc(
                'directives',
                [
                    {
                        name: 'tooltip',
                        value: account.name,
                    },
                ],
                iconProps
            );
        }

        return (
            <S.Wrapper>
                {bottomVisible && (
                    <S.Background
                        nativeOnclick={() => setBottomVisible(false)}
                    />
                )}
                <S.ContentWrapper routeName={this.$route.name}>
                    <S.ButtonsWrapper onClick={this.handleIconClick}>
                        <S.AccountIcon
                            class="accout-icon-circle"
                            {...iconProps}
                        >
                            {accountAlias}
                        </S.AccountIcon>
                        <ArrowIcon v-view-box class="arrow-icon" />
                    </S.ButtonsWrapper>
                    {renderBottom()}
                </S.ContentWrapper>
            </S.Wrapper>
        );
    },
    methods: {
        ...mapActions('user', ['setDefaultAccount', 'logout']),
        ...mapMutations('view', [
            'setLogoutModalActive',
            'setIsNewCampaignModalActive',
        ]),
        handleElemClick(id) {
            if (id !== undefined && this.accountId !== id) {
                this.changeAccount(id, this.routeMeta.canChangeAccount);
                this.setBottomVisible(false);
            }
        },
        renderBottom() {
            const { account = {}, user = {}, isMobileSize } = this;
            if (!this.bottomVisible) {
                return null;
            }

            const accountName = account.name;

            return (
                <S.Bottom>
                    <S.BottomHeader>
                        <S.UserContainer>
                            <S.AccountIconBig>
                                {headOfString(accountName)}
                            </S.AccountIconBig>
                            <S.UserInfoContainer>
                                <S.UserName>{user.name}</S.UserName>
                                <S.UserEmail>{user.email}</S.UserEmail>
                            </S.UserInfoContainer>
                        </S.UserContainer>
                        <S.SettingBtn
                            onClick={() => {
                                this.setBottomVisible(false);
                                this.pushToRoute('/Settings');
                            }}
                        >
                            {this.$t('COMMON.user_settings')}
                        </S.SettingBtn>
                    </S.BottomHeader>
                    <S.LabelContainer>
                        <S.AccountLabel>
                            {this.$t('COMMON.sub_header_tabs_workspace')}
                        </S.AccountLabel>
                        {!isMobileSize && (
                            <S.ButtonContainer>
                                {!R.equals(this.role, [
                                    ACCOUNT_ROLES_NEW.ONLY_VIEW,
                                ]) &&
                                    !this.isPlanA && (
                                        <S.AddLabel
                                            onClick={this.handleInviteClick}
                                        >
                                            <AddIcon
                                                v-view-box
                                                width="12px"
                                                height="12px"
                                            />
                                            {this.$t(
                                                'SETTINGS.account_modal_confirm_invite'
                                            )}
                                        </S.AddLabel>
                                    )}
                            </S.ButtonContainer>
                        )}
                    </S.LabelContainer>

                    <S.Divider />
                    <S.Accounts>{this.renderAccounts()}</S.Accounts>
                    <S.Divider />
                    <S.LogoutContainer>
                        <S.AddLabel
                            onClick={() => this.setLogoutModalActive(true)}
                        >
                            <LogoutIcon v-view-box width="16px" height="16px" />
                            {this.$t('COMMON.sign_out')}
                        </S.AddLabel>
                    </S.LogoutContainer>
                </S.Bottom>
            );
        },
        setBottomVisible(value) {
            this.bottomVisible = value;
            this.$emit('updateBottomVisible', value);
        },
        renderAccounts() {
            const selectedId = Number(this.accountId);

            return R.compose(
                R.map(({ name, is_default, id } = {}) => {
                    const active = selectedId == id;
                    return (
                        <S.AccountElem
                            nativeOnclick={() => this.handleElemClick(id)}
                        >
                            <S.ElemText class="adriel-ellipsis" active={active}>
                                {name}
                            </S.ElemText>
                            {is_default && (
                                <S.AccountDefault active={active}>
                                    {this.$t('SETTINGS.default_account')}
                                </S.AccountDefault>
                            )}
                            {active && (
                                <CheckIcon
                                    v-view-box
                                    width="16px"
                                    height="16px"
                                />
                            )}
                        </S.AccountElem>
                    );
                }),
                R.propOr([], 'accounts')
            )(this);
        },
        handleInviteClick() {
            this.pushToRoute('/inviteMember');
            this.setBottomVisible(false);
        },
        handleIconClick() {
            this.setBottomVisible(!this.bottomVisible);
        },
    },
};
